import { AbilityService } from 'ability';
import { PermissionsEnum } from '../../models/PermissionsEnum';

/**
 * Whether documents are open to the administrator signed in. The two roles are asked about separately:
 * the prefix a permission arrives under is dropped before the rules are built, so a sub-administrator
 * carries the flag of their provider under the same name as the provider does, and reading it would
 * answer for the provider rather than for them.
 *
 * @param {AbilityService} ability The rules built for the administrator signed in.
 * @return {boolean} True when documents may be shown.
 */
export function canSeeDocuments(ability: AbilityService): boolean {
  return ability.can('read', 'Provider')
    ? ability.can('read', PermissionsEnum.DocumentsManagement)
    : ability.can('read', PermissionsEnum.ShowDocuments);
}
